import { render, staticRenderFns } from "./Pulldown.vue?vue&type=template&id=2576d6c8&scoped=true&"
var script = {}
import style0 from "./Pulldown.vue?vue&type=style&index=0&id=2576d6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2576d6c8",
  null
  
)

export default component.exports